import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const RkSsm = React.lazy(async () => ({
    default: (await import('@oc/rk-ssm/module')).RkSsmModule
}))

export function RkSsmComponent() {
    return <SuspenseWhileLoading LazyComponent={RkSsm} />
}
